import { Injectable } from '@angular/core';
import { User } from '@app/_models';
import { BehaviorSubject } from 'rxjs';
import { filter, tap } from 'rxjs/operators';

import { BaseService } from './base.service';

@Injectable({
  providedIn: 'root'
})
export class UserService {

  private userListEndpoint = "Administration/User/List";
  private userUploadEndpoint = "Administration/User/Add";
  private userUpdateEndpoint = "Administration/User/Update";
  private userDeleteEndpoint = "Administration/User/Delete";

  // Roles
  private roleListEndpoint = "Administration/Role/List";

  private usersSubject: BehaviorSubject<User[]> = new BehaviorSubject<User[]>([]);
  private rolesSubject: BehaviorSubject<string[]> = new BehaviorSubject<string[]>([]);

  constructor(private baseService: BaseService) { }

  public refreshUserList() {
    return this.baseService.getOnceNEW<User[]>(this.userListEndpoint).pipe(
      filter(data => !!data), //mrosetti - Evito di fare refresh se la risposta è "null"
      tap(data => this._refreshUsers(data))
    );
  }

  public refreshRoleList() {
    return this.baseService.getOnceNEW<string[]>(this.roleListEndpoint).pipe(
      filter(data => !!data), //mrosetti - Evito di fare refresh se la risposta è "null"
      tap(data => this.rolesSubject.next(data))
    );
  }

  public uploadUser(user: User) { // only add
    return this.baseService.postRequestNEW<User[]>(user, this.userUploadEndpoint).pipe(
      filter(data => !!data), //mrosetti - Evito di fare refresh se la risposta è "null"
      tap(data => this._refreshUsers(data))
    );
  }

  public updateUser(user: User) { // only add
    return this.baseService.postRequestNEW<User[]>(user, this.userUpdateEndpoint).pipe(
      filter(data => !!data), //mrosetti - Evito di fare refresh se la risposta è "null"
      tap(data => this._refreshUsers(data))
    );
  }

  public deleteUsers(users: User[]) { // for both add/edit
    return this.baseService.postRequestNEW<User[]>(users, this.userDeleteEndpoint).pipe(
      filter(data => !!data), //mrosetti - Evito di fare refresh se la risposta è "null"
      tap(data => this._refreshUsers(data))
    );
  }

  private _refreshUsers(users: User[]) {
    this.usersSubject.next(users)
  }

  get users() {
    return this.usersSubject.asObservable();
  }

  get roles() {
    return this.rolesSubject.asObservable();
  }

}
